module.exports = __webpack_public_path__ + "img/article4-4.40b20257.jpg";